import { OrganizationalRole, Role } from '@pillar-portal/database/dist/frontend';

interface RoleBadgeProps {
    role: Role | string;
}

/**
 * Color-coded oval badge for roles
 * - Rep: light, faded green
 * - Admin: bright green
 * - Principal: blue
 * - No role should be red (to avoid negative impression)
 */
export function RoleBadge({ role }: RoleBadgeProps) {
    const roleString = String(role);

    let colorClasses = '';
    if (roleString === OrganizationalRole.REP) {
        colorClasses = 'bg-green-100 text-green-700 border-green-300'; // Light, faded green
    } else if (roleString === OrganizationalRole.ADMIN) {
        colorClasses = 'bg-green-500 text-white border-green-600'; // Bright green
    } else if (roleString === OrganizationalRole.PRINCIPAL) {
        colorClasses = 'bg-blue-500 text-white border-blue-600'; // Blue
    } else {
        // For other roles, use a neutral color (not red)
        colorClasses = 'bg-gray-200 text-gray-700 border-gray-400';
    }

    return (
        <span
            className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${colorClasses}`}
        >
            {roleString.replace(/_/g, ' ')}
        </span>
    );
}
